import THDCustomer from '@thd-olt-global/thd-customer';

function isAuthenticated() {
  try {
    const loggedIn = THDCustomer?.isLoggedIn;
    const isKMSI = THDCustomer?.isKMSI;
    const isPersistedKMSI = THDCustomer?.isPersistedKMSI;
    if (loggedIn) return true;
    if (isKMSI && isPersistedKMSI) return true;
    return false;
  } catch (err) {
    console.log(err);
  }

  return null;
}

export const customVariables = () => {
  if (typeof window !== 'undefined') {
    const { version, name } = window.experienceMetadata || {};
    if (window.newrelic && name && version) {
      window.newrelic.setCustomAttribute('expVersion', version);
      window.newrelic.setCustomAttribute('expName', name);
      window.newrelic.addRelease(name, version);
      setTimeout(() => {
        if (typeof window.testversion !== 'undefined') {
          window.newrelic.setCustomAttribute('tnt', window.testversion);
        }
      }, 4000);
    }
  }

  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('experience-context.ready', ({ output }) => {
    const {
      store, clientStore, segment, customer, channel, isConsumerApp
    } = output || {};
    const storeId = clientStore?.storeId || store?.storeId;
    const { type: customerType, localizationStatus } = customer || {};
    if (typeof window !== 'undefined' && window.newrelic) {
      if (segment) {
        window.newrelic.setCustomAttribute('segment', segment);
      }
      if (storeId) {
        window.newrelic.setCustomAttribute('storeId', storeId);
      }
      if (customerType) {
        window.newrelic.setCustomAttribute('customerType', customerType);
      }
      if (localizationStatus) {
        window.newrelic.setCustomAttribute('localizationStatus', localizationStatus);
      }
      if (channel) {
        window.newrelic.setCustomAttribute('channel', channel);
      }

      const isAuth = isAuthenticated();
      if (typeof isAuth !== 'undefined') {
        window.newrelic.setCustomAttribute('isLoggedIn', isAuth);
      }
      if (typeof isConsumerApp !== 'undefined') {
        window.newrelic.setCustomAttribute('isConsumerApp', isConsumerApp);
      }
    }
  });
};
